export interface LinkedTokenSet {
  id: number;
  name: string;
}

export type ConnectionMode =
  | "local"
  | "remote_single_styleguide"
  | "remote_oauth";

export interface ServerContext {
  connectionMode: ConnectionMode;
  features: Record<string, boolean>;
  styleguideId?: number;
  styleguideName?: string;
  tokenSets?: LinkedTokenSet[];
}
